import {
  AllowedMerchantTierError,
  AllowedMerchantTiersRequest,
  AllowedMerchantTiersResponse,
  GiftCardEligibilityResponse,
} from '@afterpaytouch/rules-service-api'
import { rulesService } from '..'
import { api } from '../../env'
import { v4 as uuid } from 'uuid'

export const giftCardEligibilityRequest = async ({ consumerUuid, countryCode }: AllowedMerchantTiersRequest): Promise<GiftCardEligibilityResponse> => {
  const response = await rulesService.request<AllowedMerchantTiersRequest, AllowedMerchantTiersResponse | AllowedMerchantTierError>({
    method: 'POST',
    url: `${api.RULES_SERVICE_BASE_URL}/v1/check/giftcard-eligibility`,
    data: {
      consumerUuid,
      countryCode,
    },
    headers: {
      HTTP_CORRELATION_ID: uuid() ?? Math.random().toString(36),
      source_service: 'rocketship-checkout',
    },
  })

  return response
}
